import { ComponentProps } from 'react';
import clsx from 'clsx';
import Tooltip from 'components/Tooltip';
import EyeClosedImg from 'assets/common/eye-closed.svg?react';

type Props = ComponentProps<'svg'> & {
  tooltip: string;
  qaSelector?: string;
};

function HideIcon({ tooltip, qaSelector, className, ...rest }: Props) {
  const iconClassName = clsx('cursorPointer', className);

  return (
    <Tooltip title={`Hide ${tooltip}`} placement='bottom' arrow={false}>
      <EyeClosedImg
        data-qa-selector={qaSelector}
        className={iconClassName}
        {...rest}
      />
    </Tooltip>
  );
}

export default HideIcon;
